import Component from '@glimmer/component';
import type PlatformJob from 'garaje/models/platform-job';
import { equal, match } from 'macro-decorators';

interface PlatformJobFailureSignature {
  platformJob: PlatformJob;
}

export default class PlatformJobFailure extends Component<PlatformJobFailureSignature> {
  @equal('args.platformJob.failureReason', 'No reason given') noReasonGiven!: boolean;
  @match('args.platformJob.failureReason', /^Non-JSON body returned/) invalidMessageBody!: boolean;

  get reason(): string {
    if (this.noReasonGiven) {
      return 'Unknown. No reason was provided.';
    }

    if (this.invalidMessageBody) {
      return 'Error. Could not parse invalid message body.';
    }

    return this.args.platformJob.failureReason;
  }

  <template>
    <div class="list-none p-0 m-0 leading-normal ml-4 pl-2 text-xs" data-test-platform-job-failure-reason>
      <div class="flex flex-wrap">
        <span class="w-4/12 text-carbon-50">Reason:</span>
        <span class="w-8/12">
          <code class="border-none bg-white">{{this.reason}}</code>
        </span>
      </div>
    </div>
  </template>
}
